module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-22c6c80d.png";